import { getLocale } from "../runtime";

const sv_ficountry = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Finland`
};

const ficountry = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_ficountry(inputs)
	return "fiCountry";
};

export { ficountry as "fiCountry" };